import { createApiRequest } from "@/lib/api/createApiService";
import { ESG_ENDPOINTS } from "./esg.endpoints";

export const esgService = {
  getFrameworks: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.FRAMEWORKS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getTargetSettingsById: async (targetId, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.TARGETS_SETTINGS_BY_ID(targetId),
      method: "GET",
      ...options,
    });
  },

  listTargetSettings: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.TARGETS_SETTINGS_LISTS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getDisclosures: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.DISCLOSURES,
      method: "GET",
      body: params,
      ...options,
    });
  },

  getQuantitativeTargets: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS,
      method: "GET",
      body: params,
      ...options,
    });
  },

  bulkSaveQuantitativeTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS_BULK,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  seedQuantitativeTargets: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS_SEED,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  deleteQuantitativeTargets: async (params = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.QUANT_TARGETS,
      method: "DELETE",
      body: params,
      ...options,
    });
  },

  deleteTargetSettingById: async (reportId, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_TARGET_DELETE(reportId),
      method: "DELETE",
      ...options,
    });
  },

  acceptEsgInvite: async (payload = {}, options = {}) => {
    return createApiRequest({
      url: ESG_ENDPOINTS.ESG_INVITE_ACCEPT,
      method: "POST",
      body: payload,
      ...options,
    });
  },
};
